var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_185_12640)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 36,
    height: 38,
    rx: 12,
    fill: "#FAFBFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2.5,
    width: 35,
    height: 37,
    rx: 11.5,
    stroke: "#EAE6ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.454 30.0349C19.0789 29.9027 22.8866 29.9027 23.5115 30.0349C24.0457 30.1583 24.6234 30.4466 24.6234 31.076C24.5923 31.6753 24.2407 32.2066 23.755 32.544C23.1251 33.035 22.3859 33.3459 21.6132 33.458C21.1859 33.5134 20.7659 33.5146 20.3535 33.458C19.5795 33.3459 18.8403 33.035 18.2117 32.5427C17.7247 32.2066 17.3732 31.6753 17.3421 31.076C17.3421 30.4466 17.9198 30.1583 18.454 30.0349ZM21.0565 8.5C23.6567 8.5 26.3128 9.73377 27.8906 11.7808C28.9142 13.099 29.3838 14.4158 29.3838 16.4629V16.9954C29.3838 18.5653 29.7988 19.4907 30.7119 20.557C31.4039 21.3426 31.625 22.351 31.625 23.445C31.625 24.5378 31.266 25.5752 30.5467 26.4174C29.605 27.4271 28.2769 28.0717 26.9216 28.1837C24.9574 28.3512 22.9921 28.4922 21.0006 28.4922C19.0079 28.4922 17.0438 28.4078 15.0797 28.1837C13.7231 28.0717 12.395 27.4271 11.4546 26.4174C10.7353 25.5752 10.375 24.5378 10.375 23.445C10.375 22.351 10.5974 21.3426 11.2881 20.557C12.2298 19.4907 12.6174 18.5653 12.6174 16.9954V16.4629C12.6174 14.3604 13.1417 12.9856 14.2212 11.6398C15.8263 9.67712 18.3992 8.5 20.9447 8.5H21.0565Z",
    fill: "url(#paint0_linear_185_12640)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_185_12640)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_185_12640)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 11,
    r: 5,
    fill: "#918F9A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 11,
    r: 4.5,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 11,
    r: 6,
    fill: "#BA0060",
    stroke: "white",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_185_12640",
    x: 0,
    y: 0,
    width: 42,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_185_12640"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_185_12640",
    result: "effect2_dropShadow_185_12640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_185_12640",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_185_12640",
    x: 19.5,
    y: 3,
    width: 17,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_185_12640"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.039 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_185_12640",
    result: "effect2_dropShadow_185_12640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_185_12640",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_185_12640",
    x: 21.5,
    y: 5,
    width: 13,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_185_12640"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.039 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_185_12640",
    result: "effect2_dropShadow_185_12640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_185_12640",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_185_12640",
    x1: 23.3611,
    y1: 12.6667,
    x2: 16.0111,
    y2: 27.7922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE934B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.6fa1c305ed3eb8ab9ad0bd607fc4643c.svg";
export { ForwardRef as ReactComponent };